import { ToggleField } from 'lib/iterable-hook-form/FormField';
import { ReactNode } from 'react';
import { useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { TOGGLE_SIZES } from 'ui/toggle';
import { Tooltip } from 'ui/tooltip';
import { CampaignEditorFormState } from '../../../types';
import { Caption } from './OptimizeSection.styles';

export const ExpandableToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const ExpandableToggleContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing.plusHalf};
`;

const StyledTooltip = styled(Tooltip)`
  display: flex;
`;

export type ExpandableToggleProps = {
  name: keyof CampaignEditorFormState;
  /** Optional cation text */
  caption?: ReactNode;
  /** Children 🤷‍♂️ */
  children?: ReactNode;
  /* Whether the checkbox is disabled for user interaction */
  isDisabled?: boolean;
  /* Explanation when the checkbox is disabled */
  tooltipContent?: string;
};

export const ExpandableToggle = ({
  name,
  caption,
  children,
  isDisabled = false,
  tooltipContent = '',
}: ExpandableToggleProps) => {
  const isActive = useWatch({ name });

  return (
    <ExpandableToggleWrapper data-test={`${name}-expandable-toggle`}>
      <StyledTooltip isEnabled={isDisabled && !!tooltipContent} tooltipContent={tooltipContent}>
        <ToggleField
          name={name}
          isDisabled={isDisabled}
          size={TOGGLE_SIZES.SMALL}
          data-test={`campaign-form-${name}`}
        />
      </StyledTooltip>

      <ExpandableToggleContentWrapper>
        {caption && <Caption>{caption}</Caption>}
        {isActive && children && <div data-test={`${name}-details`}>{children}</div>}
      </ExpandableToggleContentWrapper>
    </ExpandableToggleWrapper>
  );
};
